import React, { useState } from "react";

import { Grid } from "@mui/material";
import { NodeDetails } from "domains/nodes/components/node-details";
import { NodeDetailsDto } from "domains/nodes/components/common/NodeDetailsDto";
import { NodeTree } from "domains/nodes/components/node-selector";
import RootPage from "../RootPage";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import localisations from "shell/localisation";
import { reactPlugin } from "app-insights";
import { useAuth0 } from "@auth0/auth0-react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

const ManageNodesPage = () => {
    const [nodeDetails, setNodeDetails] = useState<NodeDetailsDto>({} as NodeDetailsDto);

    const [selectedNodes, setSelectedNodes] = useState<string[]>([]);

    const [refresh, setRefresh] = useState(false);

    const [showDetails, setShowDetails] = useState(false);

    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.manageNodes.heading}>
            <Grid style={{paddingTop:30}} container spacing={5}>
                <Grid item xs={12} md={6} height={800} overflow="auto">
                    <NodeTree
                        fieldCompanyId={fieldCompanyId}
                        expandedNodes={selectedNodes}
                        refresh={refresh}
                        onNodeSelect={(_: string, nodeDetails: NodeDetailsDto) => {
                            setNodeDetails(nodeDetails);
                        }}
                        onLoaded={() => {
                            setRefresh(false);
                            setShowDetails(true);
                        }}
                        onToggle={setSelectedNodes}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    {showDetails && (
                        <NodeDetails
                            fieldCompanyId={fieldCompanyId}
                            onDeleteComplete={() => {
                                setRefresh(true);
                            }}
                            onSaveComplete={() => {
                                setRefresh(true);
                            }}
                            nodeDetails={nodeDetails}
                        ></NodeDetails>
                    )}
                </Grid>
            </Grid>
        </RootPage>
    );
};

export default withAITracking(reactPlugin, ManageNodesPage, "Manage Nodes Page");
